import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class FaqSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: 0
        };
    }

    toggleFaq = (index) => {
        this.setState(prevState => ({
            activeKey: prevState.activeKey === index ? null : index
        }));
    };

    render() {
        const faqItems = [
            {
                id: 0,
                icon: 'fas fa-cube',
                title: 'What types of projects do you handle?',
                content: 'We handle a wide range of projects including web development, academic projects, industrial software solutions, mobile applications, and technical consultation. From simple websites to complex enterprise solutions, we\'ve got you covered.',
                headerClass: 'faq-header-purple'
            },
            {
                id: 1,
                icon: 'fas fa-clock',
                title: 'How long does it take to complete a project?',
                content: 'Project timelines vary based on complexity, scope, and your requirements. For simple websites, it typically takes 2-4 weeks, while more complex applications may take 2-3 months or more. We provide detailed timelines during the initial consultation and keep you updated throughout the development process.',
                headerClass: 'faq-header-blue'
            },
            {
                id: 2,
                icon: 'fas fa-headset',
                title: 'Do you provide post-development support?',
                content: 'Absolutely! We provide comprehensive post-development support including bug fixes, updates, performance optimization, and feature enhancements. Our 24/7 support team is always available to assist with any issues or questions you may have.',
                headerClass: 'faq-header-green'
            },
            {
                id: 3,
                icon: 'fas fa-code',
                title: 'What technologies do you work with?',
                content: 'We work with a variety of modern technologies including React, Node.js, Python, Java, Angular, Vue.js, and more. For mobile development, we specialize in React Native and native iOS/Android development. We also have expertise in databases like MongoDB, MySQL, PostgreSQL, and cloud platforms like AWS and Azure.',
                headerClass: 'faq-header-orange'
            }
        ];

        return (
            <div className="pt-3 position-relative overflow-hidden">
                <Container className="my-5" fluid>
                    <div className="text-center mb-5">
                        <div className="position-relative section-title">
                            <h1 className="fs28 title">Frequently Asked Questions</h1>
                            <span className="mirror-text">FAQ</span>
                        </div>
                        <span className="fs16 color-grey3">We answer your common questions</span>
                    </div>

                    <Row>
                        <Col md={12}>
                            <div className="faq-accordion">
                                {faqItems.map((item) => (
                                    <div key={item.id} className="faq-item">
                                        <div 
                                            className={`faq-header ${item.headerClass} ${this.state.activeKey === item.id ? 'active' : ''}`}
                                            onClick={() => this.toggleFaq(item.id)}
                                        >
                                            <span className="faq-icon">
                                                <i className={item.icon}></i>
                                            </span>
                                            <span className="faq-title">{item.title}</span>
                                            <span className="faq-toggle">
                                                <i className={`fas ${this.state.activeKey === item.id ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                            </span>
                                        </div>
                                        {this.state.activeKey === item.id && (
                                            <div className="faq-body">
                                                {item.content}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default FaqSection;
